import * as React from 'react';

export function SvgCaretFolder(props: any) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M20.24 7a2.6 2.6 0 00-1.84-.8h-6.67l-1.3-1.95a1 1 0 00-.83-.45h-4a2.66 2.66 0 00-1.84.76A2.6 2.6 0 003 6.4v11.2a2.6 2.6 0 00.76 1.84 2.66 2.66 0 001.84.76h12.8a2.6 2.6 0 001.84-.76A2.66 2.66 0 0021 17.6V8.8a2.6 2.6 0 00-.76-1.8zM19 17.6a.62.62 0 01-.6.6H5.6a.62.62 0 01-.6-.6V6.4a.62.62 0 01.6-.6h3.46l1.31 2a1 1 0 00.83.45h7.2a.59.59 0 01.42.17.6.6 0 01.18.38z"
        fill="currentColor"
      />
      <path
        d="M13.07 11.2L12 12.28l-1.07-1.08a1 1 0 00-1.42 1.42l1.78 1.78a1 1 0 001.42 0l1.77-1.78a1 1 0 00-1.41-1.42z"
        fill="currentColor"
      />
    </svg>
  );
}
